import { render, staticRenderFns } from "./descriptionEdition.vue?vue&type=template&id=a10f9aa8"
import script from "./descriptionEdition.vue?vue&type=script&lang=js"
export * from "./descriptionEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports